import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const FullRefSvg = props => (
  <svg
    width="25px"
    height="24px"
    viewBox="0 0 25 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g transform="translate(13.000000, 13.000000)">
      <path
        d="M0.75708,11.003 C0.558168,11.003 0.367403,10.924 0.22675,10.7833 C0.0860981,10.6427 0.00708008,10.4519 0.00708008,10.253 C0.00919728,8.46343 0.721035,6.74777 1.98645,5.48236 C3.25186,4.21695 4.96752,3.50511 6.75708,3.50299 L9.44708,3.50299 L7.72708,1.78299 C7.65681,1.71376 7.60101,1.63126 7.56293,1.54027 C7.52484,1.44928 7.50523,1.35163 7.50523,1.25299 C7.50523,1.15435 7.52484,1.0567 7.56293,0.96571 C7.60101,0.874721 7.65681,0.792214 7.72708,0.722989 C7.79664,0.653325 7.87926,0.598059 7.9702,0.560351 C8.06115,0.522644 8.15863,0.503235 8.25708,0.503235 C8.35553,0.503235 8.45301,0.522644 8.54396,0.560351 C8.6349,0.598059 8.71752,0.653325 8.78708,0.722989 L11.7871,3.72299 C11.9241,3.85719 12.0025,4.04019 12.0051,4.23199 L12.0051,4.27699 C12.003,4.37028 11.983,4.46229 11.9461,4.54799 C11.909,4.63598 11.855,4.71583 11.7871,4.78299 L8.78708,7.78299 C8.71786,7.85326 8.63535,7.90906 8.54436,7.94714 C8.45337,7.98523 8.35572,8.00484 8.25708,8.00484 C8.15844,8.00484 8.06079,7.98523 7.9698,7.94714 C7.87881,7.90906 7.7963,7.85326 7.72708,7.78299 C7.65742,7.71343 7.60215,7.63081 7.56444,7.53987 C7.52673,7.44892 7.50733,7.35144 7.50733,7.25299 C7.50733,7.15454 7.52673,7.05706 7.56444,6.96611 C7.60215,6.87517 7.65742,6.79255 7.72708,6.72299 L9.44708,5.00299 L6.75708,5.00299 C5.36518,5.00458 4.03075,5.55821 3.04652,6.54243 C2.0623,7.52666 1.50867,8.86109 1.50708,10.253 C1.50708,10.4519 1.42806,10.6427 1.28741,10.7833 C1.14676,10.924 0.955992,11.003 0.75708,11.003 Z"
        id="Shape"
      />
    </g>
    <g>
      <path
        d="M2.24999992,21.0000093 C1.65342992,20.9995093 1.08143992,20.7622093 0.65959492,20.3404093 C0.23775292,19.9186093 0.00052958,19.3466093 0,18.7500093 L0,2.24999928 C0.00052958,1.65342928 0.23775292,1.08143928 0.65959492,0.65959428 C1.08143992,0.23775228 1.65342992,0.00052959 2.24999992,0 L20.2500199,0 C20.8466199,0.00052959 21.4185199,0.23775228 21.8404199,0.65959428 C22.2622199,1.08143928 22.4994199,1.65342928 22.5000199,2.24999928 L22.5000199,10.4970093 C22.5000199,10.6959093 22.4210199,10.8867093 22.2803199,11.0273093 C22.1397199,11.1680093 21.9489199,11.2470093 21.7500199,11.2470093 C21.5511199,11.2470093 21.3603199,11.1680093 21.2196199,11.0273093 C21.0790199,10.8867093 21.0000199,10.6959093 21.0000199,10.4970093 L21.0000199,5.99999928 L1.49999992,5.99999928 L1.49999992,18.7500093 C1.49999992,19.1640093 1.83599992,19.5000093 2.24999992,19.5000093 L9.00099992,19.5000093 C9.19990992,19.5000093 9.39067992,19.5790093 9.53132992,19.7197093 C9.67197992,19.8603093 9.75099992,20.0511093 9.75099992,20.2500093 C9.75099992,20.4489093 9.67197992,20.6397093 9.53132992,20.7803093 C9.39067992,20.9210093 9.19990992,21.0000093 9.00099992,21.0000093 L2.24999992,21.0000093 Z M21.0000199,4.49999928 L21.0000199,2.24999928 C21.0000199,2.05108928 20.9210199,1.86031928 20.7803199,1.71966928 C20.6397199,1.57901928 20.4489199,1.49999928 20.2500199,1.49999928 L2.24999992,1.49999928 C2.05108992,1.49999928 1.86031992,1.57901928 1.71966992,1.71966928 C1.57901992,1.86031928 1.49999992,2.05108928 1.49999992,2.24999928 L1.49999992,4.49999928 L21.0000199,4.49999928 Z"
        id="Shape"
      />
    </g>
  </svg>
);

export const FullRefIcon = styled(FullRefSvg)`
  width: 23px;
  height: 21px;
`;

export const PlaceHolder = ({ isError }) => (
  <svg width="273" height="93" fill="none">
    <rect width="273" height="6" y="31" fill="#DCDCDC" rx="3" />
    <rect width="241" height="6" y="45" fill="#DCDCDC" rx="3" />
    <rect width="213" height="6" y="59" fill="#DCDCDC" rx="3" />
    <rect width="252" height="6" y="73" fill="#DCDCDC" rx="3" />
    <rect width="110" height="6" y="87" fill="#DCDCDC" rx="3" />
    <rect
      width="72"
      height="10"
      x={isError ? "29" : "0"}
      y="7"
      fill="#DCDCDC"
      rx="5"
    />
    <rect
      width="26"
      height="10"
      x={isError ? "109" : "89"}
      y="7"
      fill="#DCDCDC"
      rx="5"
    />
    {isError && (
      <path
        fill="#BE0000"
        d="M23.119 19L13.772 1.15a2 2 0 0 0-3.543 0L.88 19a2 2 0 0 0 1.772 2.928h18.694A2 2 0 0 0 23.119 19zM10.999 7.423a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0v-6zm1.05 11.51h-.027a1.529 1.529 0 0 1-1.522-1.47 1.476 1.476 0 0 1 1.448-1.53h.028A1.527 1.527 0 0 1 13.5 17.4a1.474 1.474 0 0 1-1.45 1.533z"
      />
    )}
  </svg>
);

PlaceHolder.propTypes = { isError: PropTypes.bool.isRequired };
